import { AxiosResponse } from "axios";
import ApiConstants from "../../../../core/constants/api_constants";
import { request } from "../../../../core/network/axiosInstance";


export class ActualityApiService {
    private readonly actualityBaseUrl: string;

    constructor() {
        this.actualityBaseUrl = ApiConstants().actuality;
    }

    async getActualityById(id: string): Promise<AxiosResponse> {
        const response = await request({
            method: "GET",
            url: `${this.actualityBaseUrl}${id}`,
            requiresToken: true,
        });
        return response;
    }
} 